import { createContext, useContext } from 'react';

export const PharmacyContext = createContext({
  workSites: [],
  workSiteId: '',
  setWorkSiteId: () => {},
  centralSite: null,
  toast: () => {},
  reloadNonce: 0,
  bumpReload: () => {},
  mode: 'central'
});

export function usePharmacy() {
  return useContext(PharmacyContext);
}
